import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
Vue.filter('tailing', function (value, tail) {
  return value + tail;
});